<template>
  <div :id="`ap-${props.wheelId}`" class="angle-picker" @mousedown="startDrag">
    <div
      :id="`ap-container-${props.wheelId}`"
      class="angle-picker-container"
      :style="arrowStyle"
    >
      <div
        :id="`ap-pointer-${props.wheelId}`"
        class="angle-picker-pointer"
        @mousedown.stop.prevent="startDrag"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";

const angle = ref(0);
const dragging = ref(false);

const props = defineProps({
  wheelId: {
    type: [String, Number],
    default: "1",
  },
  angle: {
    type: [Number, String, null],
    default: 0,
    required: true,
  },
});

const emits = defineEmits(["update-angle"]);

onMounted(() => {
  document.addEventListener("mouseup", endDrag);
});

onBeforeUnmount(() => {
  document.removeEventListener("mouseup", endDrag);
});

watch(
  () => props.angle,
  (newVal) => {
    if (newVal) {
      angle.value = newVal;
    }
  },
  { immediate: true }
);

const arrowStyle = computed(() => `transform: rotate(${angle.value}deg)`);

const calculateAngle = (x, y) => {
  const rect = document
    .getElementById(`ap-${props.wheelId}`)
    .getBoundingClientRect();
  const cx = rect.width / 2;
  const cy = rect.height / 2;
  const dx = x - cx;
  const dy = y - cy;
  let computedAngle = Math.atan2(dy, dx) * (180 / Math.PI);
  computedAngle = (computedAngle + 90) % 360;
  angle.value = computedAngle < 0 ? computedAngle + 360 : computedAngle;
  emits("update-angle", parseInt(angle.value, 10));
};

const updatePosition = (event) => {
  const rect = document
    .getElementById(`ap-${props.wheelId}`)
    .getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  calculateAngle(x, y);
};

const startDrag = (event) => {
  dragging.value = true;
  document.addEventListener("mousemove", onDrag);
  document.addEventListener("mouseup", endDrag);
  updatePosition(event);
};

const onDrag = (event) => {
  if (dragging.value) {
    updatePosition(event);
  }
};

const endDrag = () => {
  dragging.value = false;
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", endDrag);
};
</script>

<style scoped>
.angle-picker {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  width: 36px;
  height: 36px;
  border: 3px solid #d2d4d6;
  border-radius: 18px;
}

.angle-picker-container {
  position: relative;
  width: 6px;
  height: 30px;
  pointer-events: none;
}

.angle-picker-pointer {
  position: absolute;
  width: 6px;
  height: 6px;
  top: 2px;
  border-radius: 3px;
  background: #d2d4d6;
}
</style>
